module.exports = __webpack_public_path__ + "static/img/图片20.d8968c50.png";